export default __webpack_public_path__ + "static/media/meeting_docs.1c93ff5c.jpg";